import { createRouter as vCreateRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
// @ts-expect-error FIXME: missing declaration file (TS7016)
import qs from 'qs';

export default (routes: RouteRecordRaw[]) =>
  vCreateRouter({
    history: createWebHistory(),
    routes,
    parseQuery: (search) => {
      return qs.parse(search, { allowDots: true, plainObjects: true });
    },
    stringifyQuery: (query) => {
      return qs.stringify(query, { allowDots: true, encode: false, arrayFormat: 'repeat' });
    },
  });
